import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { DateTimezonePipe } from '../../pipes/date-timezone.pipe';
import { BasicService } from '../../services/basic.service';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerComponent {
  label = 'Date Range';
  selectedDates: DateRange<any>;
  dateFormat = 'dd/MM/yyyy';
  minDate: Date = moment.utc('2014-01-01T00:00:00.000Z').toDate();
  maxDate: Date = moment.utc().startOf('year').add(10, 'year').toDate();
  title: string;

  constructor(
    private basicService: BasicService,
    private dateTimezonePipe: DateTimezonePipe,
    public dialogRef: MatDialogRef<DateRangePickerComponent>,
    dateAdapter: DateAdapter<any>,
    alcmeonContextService: AlcmeonContextService,
    @Inject(MAT_DIALOG_DATA) data: { label; selectedDates; minDate: Date; maxDate: Date }
  ) {
    dateAdapter.setLocale(alcmeonContextService.lang);
    const { label, selectedDates, minDate, maxDate } = data;
    this.label = label || this.label;
    this.selectedDates = selectedDates || this.selectedDates;
    this.minDate = minDate || this.minDate;
    this.maxDate = maxDate || this.maxDate;
    this.updateTitle(this.selectedDates);
  }

  updateCustomRange(selectedDates: DateRange<Date>): void {
    this.updateSelectedDates(selectedDates.start, selectedDates.end);
  }

  clearSelection() {
    this.selectedDates = new DateRange<Date>(null, null);
  }

  updateTitle(dateRange: DateRange<any>) {
    const { start, end } = dateRange;
    if (start) {
      this.title = `${this.dateTimezonePipe.transform(moment(start).toDate())} - ${this.dateTimezonePipe.transform(
        moment(end || start).toDate()
      )}`;
    } else {
      this.title = this.basicService.translate('select-date-range/title');
    }
  }

  private updateSelectedDates(startDate: Date, endDate: Date): void {
    this.selectedDates = new DateRange<Date>(startDate, endDate || startDate);
    this.dialogRef.close(this.selectedDates);
  }
}
